export const FormatterName = {
  firstAndLast: name => {
    let names = (String(name) || '').trim().split(' ')

    return names.length > 1 ? `${names[0]} ${names[names.length - 1]}` : name
  }
}



// WEBPACK FOOTER //
// ./src/plugins/filters/FormatterName.js